import {
  OrganizationServiceApiClient,
  type OrganizationMarketing,
  type MarketingLookupReqPayload,
} from '@highereducation/organizations';
import { getApiConfig } from '@de/services';

const clientCache = new Map<string, OrganizationServiceApiClient>();

/**
 * Gets or creates a cached OrganizationServiceApiClient instance
 */
function getClient(): OrganizationServiceApiClient {
  const config = getApiConfig();
  const baseUrl =
    config.organizationServiceBaseUrl ?? config.organizationApiUrl;

  if (!baseUrl) {
    throw new Error('Organization API URL is not configured');
  }

  let client = clientCache.get(baseUrl);
  if (!client) {
    client = new OrganizationServiceApiClient({ baseUrl });
    clientCache.set(baseUrl, client);
  }
  return client;
}

/**
 * Fetches organization marketing data for the given school IDs
 *
 * @param body - The marketing lookup request payload containing school IDs
 * @param userAgent - Optional user agent string for the request
 * @returns Promise resolving to an array of organization marketing data
 */
export const fetchOrganizationMarketingData = async (
  body: MarketingLookupReqPayload,
  userAgent?: string,
): Promise<OrganizationMarketing[]> => {
  try {
    const client = getClient();

    const response = await client.postMarketingLookup(body, userAgent, {
      cacheEnabled: false,
    });

    return response.data || [];
  } catch (error) {
    console.error('Failed to fetch organization marketing data:', error);
    return [];
  }
};
